const LineClampHook = {
  mounted() {
    this.el.classList.toggle('line-clamped', this.el.scrollHeight > this.el.clientHeight);
  },
};

export default LineClampHook;
